"use client";
import { keyframes } from "@emotion/react";
import React from "react";

import { Box, BoxSx, ThemeSizes } from "../../foundations";

export interface SpinnerProps {
  size?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl";
}

export const Spinner: React.FC<SpinnerProps> = (props: SpinnerProps) => {
  const { size = "md" } = props;

  const { diameter, border } = React.useMemo(() => {
    switch (size) {
      case "xxs":
        return { diameter: "spacing-5", border: "1px solid" };
      case "xs":
        return { diameter: "spacing-6", border: "1px solid" };
      case "sm":
        return { diameter: "spacing-7", border: "2px solid" };
      case "md":
        return { diameter: "spacing-8", border: "3px solid" };
      case "lg":
        return { diameter: "spacing-9", border: "3px solid" };
      case "xl":
        return { diameter: "spacing-10", border: "3px solid" };
    }
  }, [size]);

  const spin = keyframes({
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" }
  });

  const spinStyles: BoxSx = {
    border,
    borderTop: border,
    borderColor: "surface-brand-teriary",
    borderTopColor: "onSurface-brand-primary",
    borderRadius: "radius-round",
    width: diameter as ThemeSizes,
    height: diameter as ThemeSizes,
    transform: "rotate(360deg)",
    animation: `${spin} 2s linear infinite`
  };

  return <Box sx={{ ...spinStyles }} />;
};
